<template>
	<div>
		<TopMenu />
		<router-view />
		<BottomMenu />
	</div>

</template>

<script>
	import BottomMenu from "@/components/english/footer/bottom-menu.vue";
	import TopMenu from "@/components/english/header/top-menu.vue";

	export default {
		name: 'Home',
		components: {
			TopMenu,
			BottomMenu,
		},
	}
</script>